import { commonMessage } from '@locales/intl';

export const apiUrl = process.env.REACT_APP_API;
export const apiPortalUrl = process.env.REACT_APP_API_TENANT;
export const apiMediaUrl = process.env.REACT_APP_API_MEDIA;
export const enableExposure = process.env.REACT_APP_ENABLE_EXPOSURE === 'true';

export const fixedPath = {
    privacy: `${apiUrl}${process.env.REACT_APP_PRIVACY_PATH}`,
    help: `${apiUrl}${process.env.REACT_APP_HELP_PATH}`,
    aboutUs: `${apiUrl}${process.env.REACT_APP_ABOUT_US_PATH}`,
};

export const brandName = 'Digibes CMS';
export const companyName = 'Digibes GmbH';
export const EMPTY_DETAIL = {};

export const appName = 'qr-code-admin';
export const grantType = 'password';
export const grantTypeShopAccount = 'shop_account';

export const COMMON_PROTOCOL = 'jdbc:mysql://';
export const storageKeys = {
    USER_ACCESS_TOKEN: `${appName}-user-access-token`,
    USER_REFRESH_TOKEN: `${appName}-user-refresh-token`,
    USER_KIND: `${appName}-user-kind`,
    X_TENANT: `${appName}-X-tenant`,
    TENANT_HEADER: `X-Tenant`,
    IS_ADMIN: `${appName}-isAdmin`,
};

export const AppConstants = {
    apiRootUrl: process.env.REACT_APP_API,
    contentRootUrl: `${process.env.REACT_APP_API_MEDIA}v1/file/download`,
    avatarRootUrl: `${process.env.REACT_APP_API_MEDIA}v1/file/download`,
    mediaRootUrl: `${process.env.REACT_APP_API_MEDIA}`,
    templateRootUrl: `${process.env.REACT_APP_API_MEDIA}v1/file/download-template`,
    langKey: 'vi',
    webPortal: process.env.REACT_APP_PORTAL_URL,
    sessionTimeout: process.env.REACT_APP_SESSION_TIMEOUT || 5,
    cmsUrl: process.env.REACT_APP_CMS_URL,
};

export const THEMES = {
    DARK: 'dark',
    LIGHT: 'light',
};

export const defaultLocale = 'en';
export const locales = ['en', 'de', 'vi'];

export const dataStorage = 'sessionStorage'; //sessionStorage or localStorage

export const activityType = {
    GAME: 'game',
    VIDEO: 'video',
    ARTICLE: 'article',
    FOCUS_AREA: 'focus-area',
};

export const DATE_DISPLAY_FORMAT = 'DD-MM-YYYY HH:mm';
export const DATE_SHORT_MONTH_FORMAT = 'DD MMM YYYY';
export const TIME_FORMAT_DISPLAY = 'HH:mm';
export const DATE_FORMAT_VALUE = 'DD/MM/YYYY';
export const DATE_FORMAT_DISPLAY = 'DD-MM-YYYY';
export const DATE_FORMAT_DISPLAY2 = 'DD-MM-YYYY';
export const DEFAULT_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const DEFAULT_FORMAT_ZERO_SECOND = 'DD/MM/YYYY HH:mm:00';
export const DATE_ONLY_FORMAT_VALUE = 'DD/MM';

export const navigateTypeEnum = {
    PUSH: 'PUSH',
    POP: 'POP',
    REPLACE: 'REPLACE',
};

export const articleTypeEnum = {
    URL: 'url',
    PLAIN: 'plain',
};

export const accessRouteTypeEnum = {
    NOT_LOGIN: false,
    REQUIRE_LOGIN: true,
    BOTH: null,
};

export const UploadFileTypes = {
    AVATAR: 'AVATAR',
    LOGO: 'LOGO',
    DOCUMENT: 'DOCUMENT',
    VIDEO: 'VIDEO',
};

export const LIMIT_IMAGE_SIZE = 512000;

export const STATUS_PENDING = 0;
export const STATUS_ACTIVE = 1;
export const STATUS_LOCK = -1;
export const STATUS_INACTIVE = -3;
// export const STATUS_INACTIVE = -1;
export const STATUS_DELETE = -2;

export const ORDER_DISPLAY_LAYOUT_1 = 'LAYOUT_1';
export const ORDER_DISPLAY_LAYOUT_2 = 'LAYOUT_2';
export const ORDER_DISPLAY_LAYOUT_3 = 'LAYOUT_3';

export const DEFAULT_TABLE_ITEM_SIZE = 20;
export const DEFAULT_TABLE_ITEM_UNLIMIT = 1000;
export const DEFAULT_TABLE_ITEM_SIZE_LARGE = 50;
export const DEFAULT_TABLE_PAGE_START = 0;

export const commonStatus = {
    PENDING: 0,
    ACTIVE: 1,
    INACTIVE: -3,
    DELETE: -2,
    LOCK: -1,
};

export const UserTypes = {
    ADMIN: 1,
    SHOP: 2,
};

export const commonStatusColor = {
    [commonStatus.PENDING]: 'warning',
    [commonStatus.ACTIVE]: 'green',
    [commonStatus.INACTIVE]: 'red',
    [commonStatus.DELETE]: 'red',
    [commonStatus.LOCK]: 'red',
};

export const categoryKind = {
    news: 1,
};

export const appAccount = {
    APP_USERNAME: process.env.REACT_APP_USERNAME,
    APP_PASSWORD: process.env.REACT_APP_PASSWORD,
};

export const P_CODE_GRANT_TYPE_SHOP_ACCOUNT = 'SHOP_TOKEN';

export const GROUP_KIND_ADMIN = 1;
export const GROUP_KIND_MANAGER = 2;
export const GROUP_KIND_USER = 3;

export const groupPermissionKindsOptions = [
    { label: 'Admin', value: GROUP_KIND_ADMIN },
    { label: 'Manager', value: GROUP_KIND_MANAGER },
    { label: 'User', value: GROUP_KIND_USER },
];

export const isSystemSettingOptions = [
    { label: commonMessage.showSystemSettings, value: 1 },
    { label: commonMessage.hideSystemSettings, value: 0 },
];

export const PROVINCE_KIND = 1;
export const DISTRICT_KIND = 2;
export const VILLAGE_KIND = 3;

export const SettingTypes = {
    Money: 'Money',
    Timezone: 'Timezone',
    System: 'System',
};

export const siteSelectionPath = {
    tenant: AppConstants.apiTenantUrl,
    authentication: AppConstants.apiRootUrl,
};

export const ExpiredTypes = {
    EXPIRED: 'expired',
    NEXT_MONTH_1: 'next-1-month',
    NEXT_MONTH_2: 'next-2-month',
    NEXT_MONTH_3: 'next-3-month',
    NEXT_MONTH_4: 'next-4-month',
};

export const INWEN_KIND_HUB = 1;
export const INWEN_KIND_Inwens = 2;

export const deviceInwensKinds = [
    {
        value: INWEN_KIND_HUB,
        label: 'Hub',
    },
    {
        value: INWEN_KIND_Inwens,
        label: 'Inwens',
    },
];

export const DeviceKinds = {
    DEVICE_TYPE_TABLE_QRCODE: 1,
    DEVICE_TYPE_ORDER_QRCODE: 101,
    DEVICE_TYPE_TABLET_RANDOM_QRCODE: 201,
    DEVICE_TYPE_POS: 1001,
    DEVICE_TYPE_TABLET_BOARD: 1002,
    DEVICE_TYPE_PAYMENT: 1003,
};

export const CurrentcyPositions = {
    FRONT: 1,
    BACK: 2,
};

export const MediaKinds = {
    IMAGE: 1,
    VIDEO: 2,
};

export const GoodsKinds = {
    COMMON: 1,
    CHOOSE: 5,
    // MERGE: 3,
    // CHOOSE: 4
};

export const FOOD_STATUS_SOLD_OUT = 0;

export const daysOfWeekTimeWork = [
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' },
    { value: 'sunday', label: 'Sunday' },
];

export const ValueTypes = {
    FIXED: 'FIXED',
    PERCENTAGE: 'PERCENTAGE',
};

export const PrinterTypes = {
    ALLWAYS_ASK: 1,
    DONOT_ASK: 2,
};

export const DEVICE_EXPIRE_DATE_NOT_EXPIRED = 0;
export const DEVICE_EXPIRE_DATE_EXPIRE_1_WEEK = 1;
export const DEVICE_EXPIRE_DATE_EXPIRE_2_WEEK = 2;
export const DEVICE_EXPIRE_DATE_EXPIRE_1_MONTHS = 3;
export const DEVICE_EXPIRE_DATE_EXPIRE_2_MONTHS = 4;

export const CHANGE_DEVICE_STATUS_CODE = "DEV_US";

export const NEW_REQUEST = 1;
export const ALL_REQUEST = 0;

export const HAS_RESTAURANT_DIGIBES = 1;
export const HAS_RESTAURANT_KITPLAY = 2;

export const KITPLAY = 'KITPLAY';
export const ORDER_DISPLAY = 'ORDER_DISPLAY';

export const PRINTER_MAPPING_MEDIA_KIND = 1;

export const PRINTER_TYPE_KITCHEN = 1;
export const PRINTER_TYPE_SERVING = 2;

export const DELIVERY_TRIP_STATE_PENDING = 0;
export const DELIVERY_TRIP_STATE_DELIVERING = 1;
export const DELIVERY_TRIP_STATE_DONE = 2;

export const DELIVERY_TRIP_DETAIL_STATE_CANCEL = -1;
export const DELIVERY_TRIP_DETAIL_STATE_PENDING = 0;
export const DELIVERY_TRIP_DETAIL_STATE_DELIVERING = 1;
export const DELIVERY_TRIP_DETAIL_STATE_DONE = 2;

export const ORDER_STATE_UNKNOWN = -1;
export const ORDER_STATE_PENDING = 0;
export const ORDER_STATE_ACTIVE = 1;
export const ORDER_STATE_DONE = 2;
export const ORDER_STATE_CANCEL = -2;
export const ORDER_STATE_HIDE = 3;

export const VOUCHER_TYPE_PERCENT = 1;
export const VOUCHER_TYPE_AMOUNT = 2;

export const VOUCHER_STATE_EXPIRED = 3;

export const PAYMENT_METHOD_OFFLINE_CASH = 1;
export const PAYMENT_METHOD_OFFLINE_CARD = 2;
export const PAYMENT_METHOD_ONLINE_PAYPAL = 5;
export const PAYMENT_METHOD_MERGE_PORT = 6;

export const VOUCHER_STATE_PENDING = 0;
export const VOUCHER_STATE_ACTIVE = 1;
export const VOUCHER_STATE_DONE = 2;
export const VOUCHER_STATE_SCHEDULED = 999;

export const SERVICE_QRCODE = 'QRCODE'; // Trong nhà
export const SERVICE_QRCODE_CUSTOMER = 'QRCODE_CUSTOMER'; // khach tu scan qrcode va dat hang tu tablet QRLIVE
export const SERVICE_PICKUP = 'PICKUP';
export const SERVICE_DELIVERY = 'DELIVERY';
export const SERVICE_KITPLAY = 'KITPLAY';
export const SERVICE_ORDER_DISPLAY = 'ORDER_DISPLAY';

export const TABLET_DEVICE_SERVICE_ORDER_CON = "ORDER_CON";
export const TABLET_DEVICE_SERVICE_QRLIVE = "QRLIVE";

export const DEVICE_REQUEST_TYPE_DIGIBES = 1;
export const DEVICE_REQUEST_TYPE_PI_SERVER = 2;

export const DEVICE_REQUEST_KIND_PI_SERVER = 1;
export const DEVICE_REQUEST_KIND_KITPLAY = 2;
export const DEVICE_REQUEST_KIND_ORDER_DISPLAY = 3;

export const TIME_DELETE_ARCHIVE_ORDER_DEFAULT = 1;
export const DONE_TYPE_VALUE_DONE_IMMEDIATELY = 1;
export const DONE_TYPE_VALUE_REQUIRES_APPROVAL = 2;

export const APP_DETAILS_ACTION_LIST = 'list';
export const APP_DETAILS_ACTION_DETAILS = 'details';
